import styled from '@emotion/styled'
import tw from 'twin.macro'
import { Heading } from '@pretamanger/component-library'

export const IngredientsWrapper = styled.div`
  ${tw`lg:w-full mx-auto space-y-5`}
`

/* BPS-601 - when this is done replace class name with a styled-component */
export const IngredientsText = styled.p`
  ${tw`text-grey-500`}
  .product-card & {
    ${tw`text-grey-700`}
  }
`

export const IngredientsHeading = styled(Heading)`
  ${tw`text-2xl leading-2xl tracking-lg md:text-3xl md:leading-3xl md:tracking-lg`}
`
